<template>
  <v-container>
    <h1 class="mt-10 mb-5">{{ $t('nav.about') }}</h1>
    <v-row>
      <v-col cols="12" md="6">
        <div class="item-body">
          <p><span class="bold-text">上海顺大会计师事务所有限公司</span> —— 专业信赖，携手成长</p>
          <p>自2003年11月1日成立以来，一直深耕于上海，为企业提供全面、专业、高效的审计与税务咨询服务。</p>
          <div class="item-body">
            <h3>专业服务，精益求精</h3>
            <p>我们的主要服务内容包括但不限于：</p>
            <ul class="list-marked">
              <li><span class="bold-text">审计查账：</span>确保企业财务数据的真实性和准确性。</li>
              <li><span class="bold-text">资金验证：</span>为企业资金运作提供权威认证。</li>
              <li><span class="bold-text">专项审计：</span>涵盖企业运营的多方面定制化审计服务。</li>
              <li><span class="bold-text">税务咨询：</span>内资企业全方位的税务管理咨询服务。</li>
            </ul>
          </div>
          <div class="item-body">
            <h3>核心团队，卓越实力</h3>
            <p>专业知识深厚、实战经验丰富的团队核心成员，是我们服务品质的坚实保障。</p>
            <ul class="list-marked">
              <li><span class="bold-text">专业背景：</span>团队成员均具备扎实的财务、税务理论基础和丰富的实战经验。
              </li>
              <li><span class="bold-text">服务领域：</span>专注于中小型企业、高科技新兴行业，帮助企业实现财务税务优化。
              </li>
              <li><span class="bold-text">成功案例：</span>20多年的坚持，积累了丰富的成功案例和宝贵的实践经验。</li>
            </ul>
          </div>
          <p style="text-indent: 2em;"></p>
          <p> 上海顺大会计师事务所有限公司，以专业为基石，以信赖为桥梁，致力于成为您事业道路上的坚实伙伴。</p>
          <p>我们期待与您携手共进，共创辉煌！ </p>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-img src="/assets/img/GGI2_ix9y5aix9y5aix9y.png" alt="Illustration" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'About',
}
</script>

<style scoped>
.bold-text {
  font-weight: bold;
}

.item-body {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 30px;
  line-height: 1.5;
}

.list-marked {
  text-align: left;
  font-weight: 300;
  font-size: 16px;
  margin-top: 16px;
  padding-left: 16px;
}

.list-marked>li {
  position: relative;
  padding-left: 10px;
  margin-top: 3px;
}
</style>